// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__VPkyp","emails":"CreateEditClinics_emails__1XPD6","emailTagLabel":"CreateEditClinics_emailTagLabel__3ay6e"};